export function getAnalyticsPath() {
    const DOMAIN = 'https://assets.adobedtm.com';
    const DEVELOPMENT = `${DOMAIN}/6e420e4d1161/ecfa197b9609/launch-60b0032bf1dc-development.min.js`;
    const STAGING = `${DOMAIN}/6e420e4d1161/ecfa197b9609/launch-ce0a3e201646-staging.min.js`;
    const PRODUCTION = `${DOMAIN}/6e420e4d1161/ecfa197b9609/launch-c5c967b56e06.min.js`;
    const { hostname } = window.location;
    
    if (hostname.includes('localhost')) {
      return DEVELOPMENT;
    } else if (
      hostname.includes('.int3') ||
      hostname.includes('.sit6') ||
      hostname.includes('.tat')
    ) {
      return STAGING;
    } else {
      return PRODUCTION;
    }
}